'use client'

import { Common } from '@/config/NextImport'
import Link from 'next/link'
import Image from 'next/image'
const BookAppointment = () => {
  return (
    <>
      <section className="section banner-content-section mb-0">
        <div className="p-0">
          <div className="row align-items-center mx-0">
            <div className="col-md-6 banner-content-col p-0">
              {/* <img
                src={Common.setImagePath('assets/images/jewels-showroom.jpg')}
                alt="jewels-showroom"
              /> */}
              <Image
                src={Common.setImagePath('assets/images/Visit-our-harmony-jewels.jpg')}
                alt="jewels-showroom"
                fill
                quality={85}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 412px, 470px"
                loading="lazy"
                style={{ objectFit: 'cover' }}
              />
            </div>
            <div className="col-md-6 banner-content-col p-0">
              <div className="banner-content-box text-center">
                <h3>
                  Visit our Harmony <br />
                  Jewels Showroom
                </h3>
                <p>
                  There’s something truly special about seeing your future ring in person. Visit our
                  Hatton Garden showroom to meet our team, try on your favourite engagement rings
                  and wedding bands, explore our latest designs, or collect a piece that’s already
                  yours. We’d love to welcome you and be part of your story.
                </p>
                <div className="banner-content-btn">
                  <Link
                    href="/contact-us"
                    className="btn btn-custom custom-hover"
                  >
                    Visit Us
                  </Link>
                  <Link
                    href="/book-an-appointment"
                    className="btn btn-custom custom-hover"
                  >
                    Book An Appointment
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default BookAppointment
